// Adds a default scroll to top to prevent Nuxt from attempting to save scroll position.
export default function (to, from, savedPosition) {
	if (to.path != from.path) {
		return { x: 0, y: 0 }
	}
}
